module.exports = __webpack_public_path__ + "img/normal_multiplier_5.55d8d66f.png";